import type { Customer } from '@/lib/api/customer-api'
import { m } from '@/lib/paraglide/messages'

export const APP_NAME = m.app_name()

export const ROUTES = {
    LOGIN: '/login',
    DASHBOARD: '/',
} as const

// Default shipping carrier id: the seeded "Tự giao" (self-delivery) row in
// shipping_carriers. Sent to the backend when no carrier is explicitly picked.
// Kept in sync with the migration that seeds this fixed id.
export const DEFAULT_SHIPPING_CARRIER_ID =
    '00000000-0000-0000-0000-000000000001'

export const WALKIN_CUSTOMER_ID = '00000000-0000-0000-0000-000000000001'

// KIOTVIET_WALKIN_CODE is the code of the default "Khách lẻ KiotViet" customer
// that every KiotViet invoice→order flow maps to. Unlike the POS walk-in it has
// no fixed UUID (created at runtime), so it is recognised by code. MUST match
// KiotVietWalkInCode in server/internal/usecase/customer/types.go.
export const KIOTVIET_WALKIN_CODE = 'KIOTVIET_WALKIN'

// WALKIN_CUSTOMER name/address are sent verbatim to the backend API as
// customer data — they are data values, not UI display strings.
// `name` phải khớp hàng KL-000 trong DB (migration
// 20260907073000_rename_walkin_customer) vì POS chụp tên này vào
// sales_orders.customer_name khi thu ngân không chọn khách.
export const WALKIN_CUSTOMER: Customer = {
    id: WALKIN_CUSTOMER_ID,
    code: 'KL-000',
    // eslint-disable-next-line hd-local/no-hardcoded-vietnamese
    name: 'Bán cho người tiêu dùng',
    phone: '0000000000',
    // eslint-disable-next-line hd-local/no-hardcoded-vietnamese
    address: 'Khách vãng lai',
    credit_limit: 0,
    is_active: true,
    created_at: '',
    updated_at: '',
}

// isWalkInCustomer reports whether a customer is a system-managed walk-in row
// (POS "Bán cho người tiêu dùng" by fixed id, or "Khách lẻ KiotViet" by code).
// These rows are protected on the backend (cannot be deleted/deactivated) and
// should be hidden from customer management surfaces in the UI.
export function isWalkInCustomer(
    customer: Pick<Customer, 'id' | 'code'> | null | undefined,
): boolean {
    if (!customer) return false
    return (
        customer.id === WALKIN_CUSTOMER_ID ||
        customer.code === KIOTVIET_WALKIN_CODE
    )
}
